module.exports = __webpack_public_path__ + "img/dish2.3d5a1c81.png";